import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { toUserSelectItems } from '../User.utils'

import { USER_SELECT_DROPDOWN_FLOATING_CONFIG } from './UserSelect.constants'
import { UserSelectDropdownListItemContentInfoAdditionalData } from './UserSelectDropdownListItemContentInfoAdditionalData'

import * as styles from './UserSelect.module.css'

function UserSelect({
  Control = InputSelectControl,
  dropdownFloatingConfig = USER_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData,
  listProps,
  toPreparedItems = toUserSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      listProps={{
        ...listProps,
        itemProps: {
          ...listProps?.itemProps,
          className: styles.userSelectListItem,
          contentProps: {
            ...listProps?.itemProps?.contentProps,
            infoProps: {
              ...listProps?.itemProps?.contentProps?.infoProps,
              ContentAdditionalData:
                UserSelectDropdownListItemContentInfoAdditionalData,
            },
          },
        },
      }}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default UserSelect
